import React, { MouseEvent } from 'react';
import { Badge } from '../badge/Badge';
import './TabItem.scss';

interface ITabItemProps {
  title: string;
  isActive?: boolean;
  badge?: number;
  onClick?: (event: MouseEvent) => void;
  className?: string;
}

export const TabItem = ({ title, isActive, badge, onClick, className }: ITabItemProps): JSX.Element => {
  const fullClassName = `tabs__item ${isActive ? 'tabs__item--active' : ''} ${className || ''}`;

  return (
    <button className={fullClassName} onClick={onClick}>
      {title}
      <Badge className="tabs__item-badge" count={badge} />
    </button>
  );
};
